/** Deployment hashes differ between apps. Only their branch aliases can be paired. */
export function previewServiceOrigin(
  origin: string,
  service: 'poppyai-api' | 'poppyai-chatbot'
): string | null {
  let url: URL;
  try {
    url = new URL(origin);
  } catch {
    return null;
  }
  if (!url.hostname.endsWith('.vercel.app')) return null;
  if (url.hostname === 'poppyai-web.vercel.app') return `https://${service}.vercel.app`;

  // Set at build time when this branch skipped the service (scripts/ci/preview-services.mjs).
  const devOrigin =
    service === 'poppyai-api'
      ? process.env.NEXT_PUBLIC_PREVIEW_API_ORIGIN
      : process.env.NEXT_PUBLIC_PREVIEW_CHATBOT_ORIGIN;
  if (devOrigin) return devOrigin;

  const branchPattern = /^poppyai-web-git-[a-z0-9-]+\.vercel\.app$/;
  const branchHost = branchPattern.test(url.hostname)
    ? url.hostname
    : process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL || process.env.VERCEL_BRANCH_URL;
  if (!branchHost || !branchPattern.test(branchHost))
    throw new Error('This preview is missing its matching service branch URL.');
  return `https://${branchHost.replace(/^poppyai-web-/, `${service}-`)}`;
}
